<template>
  <AppChip color="success" size="small" density="comfortable">
    {{ discount.percent }}%
  </AppChip>
</template>

<script setup lang="ts">
import type { Discount } from '~/types';

defineProps<{
  discount: Discount;
}>();
</script>